import type { ReactElement, ReactNode } from 'react';

import styles from './PageHeader.module.css';

export interface PageHeaderProps {
    title: string;
    /** Secondary line under the title, e.g. today's date. */
    subtitle?: string | undefined;
    /** Controls aligned to the end, e.g. a child selector. */
    actions?: ReactNode;
}

export function PageHeader({ title, subtitle, actions }: PageHeaderProps): ReactElement {
    return (
        <div className={styles.header}>
            <div>
                <h1>{title}</h1>
                {subtitle !== undefined ? <p className={styles.subtitle}>{subtitle}</p> : null}
            </div>
            {actions !== undefined ? <div className={styles.actions}>{actions}</div> : null}
        </div>
    );
}
